export default __webpack_public_path__ + "static/media/app_icon.019b0481.png";